/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { Children, type ReactNode } from 'react';

import { cssMap as unboundCssMap } from '@compiled/react';

import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	list: {
		display: 'flex',
		isolation: 'isolate',
		marginBlockEnd: token('space.0', '0px'),
		marginBlockStart: token('space.0', '0px'),
		marginInlineStart: token('space.0', '0px'),
		paddingBlockEnd: token('space.0', '0px'),
		paddingBlockStart: token('space.0', '0px'),
		paddingInlineEnd: token('space.0', '0px'),
		paddingInlineStart: token('space.0', '0px'),
	},
	item: {
		marginBlockEnd: token('space.0', '0px'),
		marginBlockStart: token('space.0', '0px'),
		marginInlineStart: token('space.0', '0px'),
	},
});

const unboundStyles = unboundCssMap({
	list: {
		listStyleType: 'none',
		marginInlineEnd: '1px',
	},
	item: {
		backgroundColor: token('elevation.surface'),
		borderRadius: token('radius.small'),
		boxShadow: `0 0 0 1px ${token('elevation.surface')}`,
		display: 'inline-flex',
		marginInlineEnd: '-1px',
	},
});

const DEFAULT_MAX_STACK_SIZE = 3;

export function IconStack({
	children,
	maxStackSize,
	testId,
}: {
	children: ReactNode;
	maxStackSize?: number;
	testId?: string;
}): JSX.Element {
	maxStackSize = maxStackSize ?? DEFAULT_MAX_STACK_SIZE;

	return (
		<ul aria-hidden css={[styles.list, unboundStyles.list]} data-testid={testId}>
			{Children.map(
				children,
				(child, index) =>
					child && (
						<li css={[styles.item, unboundStyles.item]} style={{ zIndex: maxStackSize - index }}>
							{child}
						</li>
					),
			)}
		</ul>
	);
}
